var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1037,
    height: 280,
    viewBox: "0 0 1037 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_973_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.057 67.7071C361.168 66.8942 357.117 67.4491 353.59 69.2781C350.063 71.1071 347.276 74.0978 345.7 77.7448L284.417 218.696L221.464 77.5758C219.85 73.9592 217.044 71.0065 213.514 69.2115C209.983 67.4164 205.944 66.888 202.071 67.7146C198.198 68.5412 194.726 70.6727 192.236 73.7525C189.746 76.8322 188.389 80.6736 188.393 84.6339V274.167H222.965V165.76L268.842 268.61C270.2 271.662 272.414 274.255 275.216 276.074C278.018 277.894 281.287 278.861 284.628 278.859C287.98 278.839 291.255 277.846 294.053 276C296.852 274.154 299.054 271.535 300.393 268.462L344.263 167.767V274.125H378.835V84.6339C378.835 80.6584 377.465 76.8043 374.955 73.7211C372.445 70.6378 368.95 68.5139 365.057 67.7071Z",
    fill: "url(#paint0_linear_973_24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.965 141.881C680.649 141.881 663.083 149.157 650.132 162.108C637.181 175.059 629.905 192.625 629.905 210.94C629.905 229.256 637.181 246.822 650.132 259.773C663.083 272.724 680.649 280 698.965 280V245.449C692.907 245.453 686.955 243.861 681.707 240.835C676.459 237.809 672.1 233.455 669.069 228.21C666.037 222.965 664.439 217.015 664.436 210.957C664.433 204.899 666.025 198.948 669.051 193.7C672.078 188.452 676.433 184.094 681.678 181.062C686.923 178.031 692.873 176.434 698.931 176.432C704.989 176.429 710.94 178.021 716.188 181.048C721.435 184.075 725.793 188.43 728.824 193.675H698.965V228.226H750.759C753.028 228.226 755.275 227.779 757.371 226.91C759.467 226.041 761.372 224.768 762.975 223.162C764.578 221.557 765.85 219.651 766.716 217.554C767.583 215.457 768.027 213.209 768.024 210.94C768.002 192.631 760.719 175.079 747.772 162.133C734.826 149.186 717.273 141.903 698.965 141.881Z",
    fill: "url(#paint1_linear_973_24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.65 141.881C829.334 141.881 811.768 149.157 798.817 162.108C785.866 175.059 778.59 192.625 778.59 210.94C778.59 229.256 785.866 246.822 798.817 259.773C811.768 272.724 829.334 280 847.65 280V245.449C841.591 245.456 835.637 243.868 830.387 240.844C825.137 237.821 820.775 233.468 817.741 228.224C814.706 222.98 813.106 217.029 813.1 210.97C813.095 204.912 814.685 198.958 817.71 193.709C820.736 188.46 825.09 184.099 830.335 181.066C835.58 178.034 841.531 176.435 847.59 176.432C853.648 176.428 859.601 178.02 864.85 181.047C870.098 184.074 874.457 188.43 877.488 193.675H847.65V228.226H899.423C904.008 228.226 908.405 226.405 911.647 223.163C914.888 219.922 916.71 215.525 916.71 210.94C916.687 192.631 909.404 175.079 896.458 162.133C883.511 149.186 865.959 141.903 847.65 141.881Z",
    fill: "url(#paint2_linear_973_24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.015 141.881C442.066 141.905 432.253 144.196 423.321 148.578C414.39 152.96 406.573 159.319 400.465 167.173C394.358 175.026 390.119 184.168 388.07 193.904C386.022 203.64 386.219 213.714 388.644 223.363C391.07 233.012 395.662 241.981 402.071 249.591C408.48 257.2 416.538 263.25 425.634 267.281C434.73 271.312 444.624 273.219 454.567 272.856C464.509 272.493 474.238 269.87 483.016 265.186V274.844H517.588V201.198H517.271C515.697 184.975 508.145 169.917 496.084 158.953C484.023 147.99 468.315 141.904 452.015 141.881ZM452.015 238.433C445.884 238.433 439.89 236.615 434.792 233.209C429.694 229.802 425.72 224.961 423.374 219.296C421.028 213.631 420.414 207.398 421.61 201.384C422.806 195.371 425.759 189.847 430.094 185.512C434.43 181.176 439.954 178.223 445.967 177.027C451.981 175.831 458.214 176.445 463.879 178.791C469.543 181.138 474.385 185.111 477.791 190.209C481.198 195.307 483.016 201.301 483.016 207.432C483.005 215.651 479.735 223.53 473.924 229.341C468.112 235.152 460.234 238.422 452.015 238.433Z",
    fill: "url(#paint3_linear_973_24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.41 151.665C1032.97 148.827 1030.77 146.444 1028.05 144.78C1025.34 143.116 1022.22 142.237 1019.03 142.24H932.77V176.812H985.283L930.487 252.613C928.597 255.192 927.46 258.245 927.203 261.432C926.946 264.619 927.579 267.815 929.032 270.664C930.484 273.512 932.7 275.901 935.43 277.565C938.161 279.228 941.301 280.1 944.498 280.084H1031.35V245.449H978.309L1033.1 169.648C1034.96 167.063 1036.06 164.015 1036.29 160.841C1036.53 157.668 1035.87 154.492 1034.41 151.665Z",
    fill: "url(#paint4_linear_973_24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.183 147.713H526.611V274.168H561.183V191.9H614.288V157.349H561.183V147.713Z",
    fill: "url(#paint5_linear_973_24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3796 275.774C65.2824 275.778 49.5455 271.008 36.1594 262.067C22.7734 253.127 12.3396 240.417 6.17751 225.546C0.0154546 210.675 -1.59793 194.311 1.54145 178.523C4.68083 162.735 12.4318 148.232 23.8142 136.85C35.1967 125.467 49.6991 117.716 65.4872 114.577C81.2752 111.438 97.6399 113.051 112.511 119.213C127.382 125.375 140.091 135.809 149.032 149.195C157.972 162.581 162.742 178.318 162.738 194.415C162.738 199.812 160.594 204.988 156.778 208.805C152.961 212.621 147.785 214.765 142.388 214.765H81.3796V174.107H116.543C112.969 167.937 107.834 162.816 101.654 159.259C95.4737 155.702 88.4666 153.834 81.336 153.841C74.2053 153.849 67.2024 155.734 61.0304 159.305C54.8584 162.876 49.7345 168.008 46.1737 174.186C42.6129 180.364 40.7403 187.37 40.7441 194.5C40.748 201.631 42.6282 208.635 46.1956 214.809C49.7631 220.983 54.8922 226.11 61.068 229.674C67.2439 233.239 74.2489 235.115 81.3796 235.115V275.774Z",
    fill: "url(#paint6_linear_973_24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3586 101.244C100.277 101.244 115.614 85.9073 115.614 66.9887C115.614 48.0702 100.277 32.7336 81.3586 32.7336C62.44 32.7336 47.1035 48.0702 47.1035 66.9887C47.1035 85.9073 62.44 101.244 81.3586 101.244Z",
    fill: "url(#paint7_linear_973_24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.32 22.6325H168.866C168.857 22.6165 168.852 22.5983 168.852 22.5797C168.852 22.5612 168.857 22.5429 168.866 22.5268V11.0944C168.918 8.39166 167.965 5.76587 166.193 3.72451C164.421 1.68316 161.955 0.371243 159.272 0.04233C157.81 -0.0838807 156.338 0.0958024 154.949 0.569987C153.561 1.04417 152.286 1.80242 151.206 2.79644C150.127 3.79046 149.266 4.99847 148.679 6.34345C148.093 7.68843 147.792 9.14093 147.798 10.6084V22.5902V22.6959H136.09C133.388 22.6445 130.762 23.5968 128.721 25.3688C126.679 27.1409 125.367 29.6068 125.038 32.2899C124.912 33.7519 125.092 35.2241 125.566 36.6129C126.04 38.0016 126.798 39.2763 127.792 40.3559C128.786 41.4354 129.995 42.2959 131.34 42.8828C132.685 43.4697 134.137 43.77 135.604 43.7646H147.586V55.2181C147.515 57.9394 148.464 60.5888 150.248 62.6456C152.031 64.7025 154.519 66.018 157.223 66.3336C158.685 66.4598 160.157 66.2802 161.545 65.806C162.934 65.3318 164.209 64.5735 165.288 63.5795C166.368 62.5854 167.229 61.3775 167.815 60.0325C168.402 58.6875 168.703 57.235 168.697 55.7676V43.7857H180.7C182.168 43.7911 183.62 43.4909 184.965 42.904C186.31 42.3171 187.518 41.4564 188.512 40.3769C189.506 39.2974 190.265 38.0227 190.739 36.634C191.213 35.2453 191.393 33.773 191.266 32.311C190.968 29.6272 189.682 27.1503 187.659 25.3616C185.636 23.5729 183.02 22.6002 180.32 22.6325Z",
    fill: "url(#paint8_linear_973_24)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_973_24",
    x1: 283.656,
    y1: 53.4852,
    x2: 283.656,
    y2: 227.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F21167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_973_24",
    x1: 698.965,
    y1: 53.4853,
    x2: 698.965,
    y2: 227.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F21167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_973_24",
    x1: 847.65,
    y1: 53.4853,
    x2: 847.65,
    y2: 227.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F21167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E91461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_973_24",
    x1: 452.015,
    y1: 53.4852,
    x2: 452.015,
    y2: 227.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F21167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_973_24",
    x1: 981.733,
    y1: 53.4853,
    x2: 981.733,
    y2: 227.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F21167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_973_24",
    x1: 570.46,
    y1: 53.4853,
    x2: 570.46,
    y2: 227.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F21167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_973_24",
    x1: -0.0000742159,
    y1: 194.415,
    x2: 162.738,
    y2: 194.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0055A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_973_24",
    x1: 47.1035,
    y1: 66.9887,
    x2: 115.635,
    y2: 66.9887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0055A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_973_24",
    x1: 125.06,
    y1: 33.1774,
    x2: 191.393,
    y2: 33.1774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F21167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32248"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_973_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1036.32,
    height: 280,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3653034235b5d2021caed437650a1d44.svg";
export { ForwardRef as ReactComponent };